import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const DataSubjectRight = () => {
  const rights = [
    {
      title: 'Right of Access',
      description:
        'You have the right to request a copy of the personal data we hold about you and to verify that we are processing it lawfully.',
    },
    {
      title: 'Right to Rectification',
      description:
        'You may request correction of any inaccurate or incomplete personal data we hold about you.',
    },
    {
      title: 'Right to Erasure',
      description:
        'You may request deletion of your personal data where there is no compelling reason for its continued processing, subject to our legal obligations.',
    },
    {
      title: 'Right to Restriction of Processing',
      description:
        'You have the right to ask us to suspend the processing of your personal data in certain circumstances, for example if you contest the accuracy of the data.',
    },
    {
      title: 'Right to Data Portability',
      description:
        'Where processing is based on your consent or a contract, you may request that we transfer your personal data to you or a third party in a structured, commonly used, machine-readable format.',
    },
    {
      title: 'Right to Object',
      description:
        'You have the right to object to the processing of your personal data where we rely on a legitimate interest (or those of a third party) as the legal basis for processing.',
    },
    {
      title: 'Right to Withdraw Consent',
      description:
        'Where processing is based on your consent, you may withdraw that consent at any time. Withdrawal will not affect the lawfulness of processing before the withdrawal.',
    },
  ];

  const paragraphs = [
    `Under applicable data protection law — including the Nigeria Data Protection Regulation (NDPR) — you have certain rights with respect to your personal data. These rights are set out below. Please note that some of these rights are not absolute and may be subject to our own legitimate interests and regulatory requirements.`,
    `To exercise any of these rights, please contact us at info@topibrotech.com. We will respond to your request within a reasonable timeframe and no later than 30 days from receipt. We may need to verify your identity before processing your request.`,
    `It is clarified, for the removal of doubt, that where personal data was provided by an employer or company administrator on your behalf, certain data subject rights may need to be exercised through that organization. Data subject rights cannot be exercised in a manner inconsistent with the rights of Topibro Technologies employees and staff, proprietary rights, or the rights of third parties.`,
  ];

  return (
    <Container sx={{ my: 10 }} id="datasubjectrights">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            DATA SUBJECT RIGHTS
          </Typography>

          {paragraphs.map((text, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {text}
            </Typography>
          ))}

          <Box sx={{ mt: 3 }}>
            {rights.map((right, i) => (
              <Box key={i} sx={{ mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {i + 1}. {right.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 400, color: 'text.secondary', ml: 2 }}
                >
                  {right.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default DataSubjectRight;
